<!--
 * @Author: Ali2vu <751815097@qq.com>
 * @Date: 2020-12-21 16:52:23
 * @LastEditors: Ali2vu
 * @LastEditTime: 2021-01-15 14:26:25
-->
<template>
  <el-button :type="type" :size="size" :disabled="isDisable" @click="handleClick">{{this.buttonTitle}}</el-button>
</template>
<script>
export default {
  name: 'commonbutton',
  props: {
    buttonTitle: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: ''
    },
    size: {
      type: String,
      default: 'small'
    },
    isDisable: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleClick() {
      this.$emit('buttonClick')
    }
  },
}
</script>